import React from "react";
import { InfiniteSearchSelect } from "./InfiniteSearchSelect";
import { useInfiniteMakkahPilgrimGroupNameMappingsQuery } from "@/services/basicData/basicData";

/**
 * Infinite-scroll select for Makkah pilgrim group name mappings (same API as makkah/basic-data/makkah-pilgrim-group-name-mappings).
 * Use in filters to select a mapping; selected value is sent as filter param (e.g. pilgrim_group_name_mapping_id).
 */
export const PilgrimGroupNameMappingInfiniteSelect = ({
  mission_id,
  company_id,
  queryParams = {},
  ...props
}) => {
  const getItemsFromPage = (page) => page?.data?.data?.data ?? [];

  const mapItemToOption = (item) => ({
    value: item.id,
    label:
      item?.mapped_group_name ||
      [item.id, item.mission_id, item.company_id].filter(Boolean).join(" - ") ||
      String(item.id),
  });

  return (
    <InfiniteSearchSelect
      queryHook={useInfiniteMakkahPilgrimGroupNameMappingsQuery}
      queryParams={{
        ...queryParams,
        mission_id: mission_id || undefined,
        company_id: company_id || undefined,
      }}
      getItemsFromPage={getItemsFromPage}
      mapItemToOption={mapItemToOption}
      allowClear
      {...props}
    />
  );
};
